/**
 * Helper function to return a string without dash and numeric index,
 * for example used for stripping this index information from form input fields
 * occuring multiple times on a page
 */
export default (input) => input.replace(/-\d/gi, "");
